import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Text from '../components/Text';
import Row from '../components/Row';
import { AppRoutes } from '../interfaces/store/appStore';
import { useNavigate } from 'react-router-dom';

const BannerWrapper = styled.div`
  height: 80px;
  background: linear-gradient(to right, #5964FF, #8b5cf6);
  color: white;
  padding: 12px 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 5vw;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`;

const CodeButton = styled.button`
  background-color: #fbbf24;
  color: #111827;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #fcd34d;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const CountdownContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const TimeUnit = styled.div`
  text-align: center;
`;

const TimeValue = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 18px;
  font-weight: bold;
`;

const TimeLabel = styled.div`
  font-size: 12px;
  margin-top: 4px;
`;

const Separator = styled.span`
  font-family: 'Courier New', monospace;
  font-size: 18px;
  font-weight: bold;
`;

const CTAButton = styled.a`
  background-color: #fbbf24;
  color: #111827;
  padding: 4px 16px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s;
  margin-left: 16px;

  &:hover {
    background-color: #fcd34d;
  }

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const BannerCountdown = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const targetDate = new Date('2025-10-01T23:59:59-07:00'); // Pacific Time (PDT)
    
    const updateCountdown = () => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      
      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (value: any) => value.toString().padStart(2, '0');

  return (
    <BannerWrapper>
      <Container>
        <Row alignItems gap='5px'>
          <Text $paragraph1 $bold $white>
            Go yearly and lock in current prices on any plan forever before they increase next month + save 30%.
          </Text>
          <CTAButton onClick={() => navigate(AppRoutes.BILLING)}>
            Go Yearly
          </CTAButton>
          {/* <CodeButton 
            onClick={() => navigator.clipboard.writeText('OFF50')}
            title="Click to copy code"
          >
            OFF50
          </CodeButton> */}
        </Row>

        <RightSection>
          <CountdownContainer>
            <TimeUnit>
              <TimeValue>{formatTime(timeLeft.days)}</TimeValue>
              <TimeLabel>Days</TimeLabel>
            </TimeUnit>
            <Separator>:</Separator>
            <TimeUnit>
              <TimeValue>{formatTime(timeLeft.hours)}</TimeValue>
              <TimeLabel>Hrs</TimeLabel>
            </TimeUnit>
            <Separator>:</Separator>
            <TimeUnit>
              <TimeValue>{formatTime(timeLeft.minutes)}</TimeValue>
              <TimeLabel>Min</TimeLabel>
            </TimeUnit>
            <Separator>:</Separator>
            <TimeUnit>
              <TimeValue>{formatTime(timeLeft.seconds)}</TimeValue>
              <TimeLabel>Sec</TimeLabel>
            </TimeUnit>
          </CountdownContainer>

        </RightSection>
      </Container>
    </BannerWrapper>
  );
};

export default BannerCountdown;